import i18n from "../i18n";
const LANGUAGES = {
    en: 1,
    cn: 0,
};
export function getCurLanguage() {
    return LANGUAGES[i18n.language] || 0;
}
